import { render, staticRenderFns } from "./scholarDataEvaluation.vue?vue&type=template&id=225093e1&scoped=true"
import script from "./scholarDataEvaluation.vue?vue&type=script&lang=js"
export * from "./scholarDataEvaluation.vue?vue&type=script&lang=js"
import style0 from "./scholarDataEvaluation.vue?vue&type=style&index=0&id=225093e1&prod&lang=scss"
import style1 from "./scholarDataEvaluation.vue?vue&type=style&index=1&id=225093e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225093e1",
  null
  
)

export default component.exports